import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

interface SplitISODateTimeResult {
  time: string
  date: string
}

export function getCurrentTimeFormatted() {
  const now = dayjs()

  const isoString = now.startOf('day').utc().toISOString()

  const hour = now.hour()
  const timeString = `${hour}:00`

  return {
    isoString,
    timeString,
  }
}

export function combineDateAndTimeToISO(
  dateStr: string,
  timeStr: string,
): string {
  const [hour, minute] = timeStr.split(':').map(Number)
  const combined = dayjs(dateStr)
    .hour(hour)
    .minute(minute)
    .second(0)
    .millisecond(0)
  return combined.utc().toISOString()
}

export function splitISODateTime(timestamp: number): SplitISODateTimeResult {
  const d = dayjs(timestamp * 1000)

  const hour = d.hour()

  return {
    date: d.startOf('day').utc().toISOString(),
    time: `${hour}:00`,
  }
}
